import { useCallback, useEffect, useState } from "react";

export const useReadingProgress = (contentRef: React.MutableRefObject<HTMLDivElement | null>) => {
  const [completion, setCompletion] = useState<number>(0);

  const scrollListener = useCallback(() => {
    if (!contentRef.current) {
      return;
    }

    const element = contentRef.current;

    const totalHeight = element.clientHeight - element.offsetTop - window.innerHeight;

    const windowScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (windowScrollTop === 0) {
      return setCompletion(0);
    }

    if (windowScrollTop > totalHeight) {
      return setCompletion(100);
    }

    setCompletion((windowScrollTop / totalHeight) * 100);
  }, [contentRef]);

  useEffect(() => {
    window.addEventListener("scroll", scrollListener);
    return () => window.removeEventListener("scroll", scrollListener);
  }, []);

  return completion;
};
